<template>
  <a-modal
    class="contact-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #name>
        <a-input
          v-decorator="['name',{rules: [
            { required: true, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入标签名称"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import {
  formData,
} from '../data/index';
export default{
  props: ['title', 'visible', 'btnIsLoading'],
  data(){
    return{
      formData,
    };
  },
  mounted(){
  },

};
</script>